var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import BackBtn from '../../BackBtn';
import { Row, PickButton } from '../MoveControls';
import { matchLabel, holdingLabel } from '../moveHelpers';
var HoldingPickStep = function (_a) {
    var productMatch = _a.productMatch, onPick = _a.onPick, onBack = _a.onBack;
    var t = useTranslation().t;
    return (_jsxs("div", { children: [_jsx(Row, { label: t('Item'), value: productMatch ? matchLabel(productMatch) : '' }, void 0), _jsx("h2", __assign({ className: 'mb-2 mt-3 text-sm font-bold text-gray-700' }, { children: t('Where is it being taken from?') }), void 0), _jsx("div", __assign({ className: 'space-y-2' }, { children: ((productMatch === null || productMatch === void 0 ? void 0 : productMatch.holdings) || []).map(function (h, i) { return (_jsx(PickButton, { label: holdingLabel(h, t), onClick: function () { return onPick(h); } }, "h-" + i)); }) }), void 0), _jsx("div", __assign({ className: 'mt-4' }, { children: _jsx(BackBtn, { onClick: onBack, type: 'button' }, void 0) }), void 0)] }, void 0));
};
export default HoldingPickStep;
